export default function PageText({ children }) {
  return (
    <div className="text-white text-base sm:text-lg md:text-xl leading-relaxed">
      {children}
    </div>
  );
}
